import { Pending } from "@mui/icons-material";
import { Button, Stack, Tooltip } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

import { GqlMedia } from "~/__generated__";
import { getFileTypeIcon } from "~/modules/media/utils/mediaUtils";

type Props = {
    medias: GqlMedia[];
    onMediaClick?: (media: GqlMedia) => void;
};

export default function MediaList({ medias, onMediaClick }: Props) {
    const { t } = useTranslation("planner");

    return medias.length > 0 ? (
        <Stack direction="row" gap={1} flexWrap="wrap">
            {medias.map(media => {
                const handleClick = () => {
                    onMediaClick?.(media);
                };

                return media.mimeType.startsWith("image") ? (
                    typeof media.url === "string" ? (
                        <Tooltip key={media.id} title={media.name ?? t("plannerMediaDisplay.labelUnknownFile")} arrow>
                            <Button onClick={handleClick} sx={{ height: 60, width: 60, overflow: "hidden" }} variant="contained">
                                <img
                                    alt={media.name ?? t("plannerMediaDisplay.labelUnknownFile")}
                                    src={media.url}
                                    style={{ width: "100%", height: "100%" }}
                                />
                            </Button>
                        </Tooltip>
                    ) : (
                        <Tooltip key={media.id} title={t("plannerMediaPreviewDialog.notUploaded")} arrow>
                            <Button sx={{ height: 60, width: 60, overflow: "hidden" }} variant="contained">
                                <Pending />
                            </Button>
                        </Tooltip>
                    )
                ) : (
                    <Button
                        key={media.id}
                        onClick={handleClick}
                        sx={{ height: 60, width: "100%" }}
                        startIcon={getFileTypeIcon(media.mimeType)}
                        variant="outlined"
                        disabled={!media.isUploaded}
                    >
                        {media.name}
                    </Button>
                );
            })}
        </Stack>
    ) : (
        <Fragment />
    );
}
